<div class="btw-row">
    <div class="btw-col-12 mb-20 mt-5">
        <btw-card [title]="indicatorName">
            <span [innerText]="description"></span>
        </btw-card>
    </div>
</div>

@if(dataSource) {
    <div class="btw-row">
        <div class="btw-col-12">
            <btw-chart [dataSource]="dataSource">
                <btw-chart-series name="Outflows" valueField="sumDebit" type="line" />
                <btw-chart-series name="Inflows" valueField="sumCredit" type="line" />
    
                <btw-chart-argument-axis field="date" type="timeseries">
                    <btw-chart-axis-tick format="%Y-%m-%d" />
                </btw-chart-argument-axis>
    
                <btw-chart-zoom [enabled]="true" />
                <btw-chart-tooltip [linked]="true" />
                
                <btw-chart-selection
                    [enabled]="true"
                    [draggable]="false"
                    [grouped]="true" 
                    (onSelected)="handleSelected($event)"
                    (onUnselected)="handleUnselected($event)"/>

            </btw-chart>
        </div>
    </div>
    
    <div class="btw-row">
        <div class="btw-col-12">
            <btw-chart [dataSource]="dataSource">
                <btw-chart-series name="# of transactions" valueField="countOfStatements" type="line" />
    
                <btw-chart-argument-axis field="date" type="timeseries">
                    <btw-chart-axis-tick format="%Y-%m-%d" />
                </btw-chart-argument-axis>
    
                <btw-chart-zoom [enabled]="true" />
                <btw-chart-tooltip [linked]="true" />
            </btw-chart>
        </div>
    </div>
    
    <div class="btw-row">
        @for (indicatorValue of indicatorValuesDataSourcesMap.keys(); track indicatorValue) {
        <div class="btw-col-6">
            <btw-chart [dataSource]="indicatorValuesDataSourcesMap.get(indicatorValue)">
                <btw-chart-series [name]="indicatorValue" valueField="value" type="line" />
    
                <btw-chart-argument-axis field="date" type="timeseries" [visible]="false">
                    <btw-chart-axis-tick format="%Y-%m-%d" />
                </btw-chart-argument-axis>
    
                <btw-chart-tooltip [linked]="true" />
            </btw-chart>
        </div>
        }
    </div>
}
